import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * DEPRECATED — the backend now completes the OAuth flow server-side and
 * redirects the browser directly to the requested next path with a session
 * cookie already set. This route exists as a safety net for stale bookmarks
 * or legacy inbound links; it simply forwards to the requested `next` path
 * or the homepage.
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  useEffect(() => {
    const next = params.get("next") || "/";
    const safe = next.startsWith("/") && !next.startsWith("//") ? next : "/";
    nav(safe, { replace: true });
  }, [nav, params]);
  return (
    <div className="min-h-screen flex items-center justify-center text-[var(--bb-ink)]/60 text-sm">
      Redirecting…
    </div>
  );
}
